import { type SVGProps } from 'react';

export const Forums = ({
  className,
  fill = '#FE3B1F',
  ...rest
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className={className}
      fill={fill}
      height="14"
      viewBox="0 0 15 14"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.9 0H13.1C13.87 0 14.493 0.63 14.493 1.4L14.5 14L11.7 11.2H1.9C1.13 11.2 0.5 10.57 0.5 9.8V1.4C0.5 0.63 1.13 0 1.9 0ZM9.6 6.3H11V4.9H9.6V6.3ZM6.8 6.3H8.2V4.9H6.8V6.3ZM4 6.3H5.4V4.9H4V6.3Z"
        fill={fill}
      />
    </svg>
  );
};
